import { useParams, Link } from "react-router-dom";
import { tuDienTheoSlug, CUM, thuatNguLienQuan } from "../data/glossary.js";
import { noiDungTheoSlug } from "../data/glossaryContent.js";
import { anhThuatNgu } from "../data/glossaryImages.js";
import { TOOLS } from "../data/tools.js";
import NotFound from "./NotFound.jsx";
import NextStep from "../components/NextStep.jsx";
import DoanVan from "../components/DoanVan.jsx";
import { THUAT_NGU, THUAT_NGU_MAC_DINH } from "../data/nextSteps.js";
import XemNhanh from "../components/VideoNgan.jsx";
import { videoCuaTrang } from "../data/videos.js";

/**
 * Trang một thuật ngữ. Hoàn toàn tĩnh nên được render sẵn lúc build — đây là
 * lớp nội dung đầu phễu, giá trị của nó nằm ở chỗ Google đọc được không cần
 * JavaScript.
 */
export default function GlossaryTerm() {
  const { slug } = useParams();
  const muc = tuDienTheoSlug(slug);
  const nd = noiDungTheoSlug(slug);

  if (!muc || !nd) return <NotFound />;

  const lienQuan = thuatNguLienQuan(slug, nd.lienQuan);
  const congCu = muc.relatedTools
    .map((id) => TOOLS.find((t) => t.toolId === id))
    .filter((t) => t && t.status === "READY");

  return (
    <article className="van-ban">
      <p className="ngay">
        <Link to="/thuat-ngu">Từ điển gọi vốn</Link> / {CUM[muc.cum]}
      </p>
      <h1>{muc.term}</h1>
      <p className="tom-tat">{muc.shortDef}</p>
      {nd.capNhat && (
        <p className="ngay-cap-nhat">
          Cập nhật {nd.capNhat.split("-").reverse().join("/")}
        </p>
      )}
      <XemNhanh ds={videoCuaTrang(`/thuat-ngu/${muc.slug}`)} path={`/thuat-ngu/${muc.slug}`} />
      {anhThuatNgu(muc.slug) && (
        <figure className="anh-thuat-ngu">
          <img src={anhThuatNgu(muc.slug)} alt={`Minh hoạ: ${muc.term}`} width="1600" height="900" loading="lazy" decoding="async" />
        </figure>
      )}

      {/* Cụm pháp lý cần cảnh báo đặt ngay đầu trang, không phải cuối trang.
          Người đọc mục này thường đang chuẩn bị làm một việc có hậu quả thật,
          và dòng nhắc ở cuối bài thì họ đã hành động trước khi đọc tới. */}
      {muc.cum === "PHAP_LY" && (
        <div className="co MEDIUM" style={{ margin: "0 0 1.5rem" }}>
          <p>
            <strong>Đây không phải tư vấn pháp lý.</strong>
          </p>
          <p className="sua">
            Trang này chỉ nêu vấn đề tồn tại và những gì thường được hỏi trong
            thẩm định. Quy định pháp luật thay đổi theo thời gian và mỗi tình
            huống một khác. Trước khi ký hay nộp bất cứ văn bản nào, hãy tham
            vấn luật sư.
          </p>
        </div>
      )}

      {nd.body.map((khoi) => (
        <section key={khoi.h}>
          <h2>{khoi.h}</h2>
          {(khoi.p || []).map((doan, i) => (
            <p key={i}>
              <DoanVan chu={doan} />
            </p>
          ))}
          {khoi.li && (
            <ul className="tn-ds">
              {khoi.li.map((y, i) => (
                <li key={i}>
                  <DoanVan chu={y} />
                </li>
              ))}
            </ul>
          )}
          {khoi.bang && (
            <div className="tn-bang-cuon">
              <table className="tn-bang">
                {khoi.bang.chuThich && <caption>{khoi.bang.chuThich}</caption>}
                <thead>
                  <tr>
                    {khoi.bang.cot.map((c) => (
                      <th key={c} scope="col">{c}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {khoi.bang.hang.map((h, i) => (
                    <tr key={i}>
                      {h.map((o, j) =>
                        j === 0 ? (
                          <th key={j} scope="row"><DoanVan chu={o} /></th>
                        ) : (
                          <td key={j}><DoanVan chu={o} /></td>
                        ),
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {(khoi.sau || []).map((doan, i) => (
            <p key={"s" + i}>
              <DoanVan chu={doan} />
            </p>
          ))}
        </section>
      ))}

      <NextStep
        tieuDe={congCu.length ? "Áp dụng vào startup của bạn" : "Đọc tiếp"}
        nguon={"thuat-ngu:" + slug}
        steps={
          THUAT_NGU[slug] ||
          (congCu.length
            ? [...congCu.map((t) => ({ tool: t.toolId })), ...THUAT_NGU_MAC_DINH]
            : THUAT_NGU_MAC_DINH)
        }
      />

      {nd.faq.length > 0 && (
        <section className="hoi-dap">
          <h2>Câu hỏi thường gặp</h2>
          {nd.faq.map((f) => (
            <div key={f.q} className="mot-hoi">
              <h3>{f.q}</h3>
              <p>
                <DoanVan chu={f.a} />
              </p>
            </div>
          ))}
        </section>
      )}

      {lienQuan.length > 0 && (
        <section className="tn-lien-quan">
          <h2>Thuật ngữ liên quan</h2>
          <ul>
            {lienQuan.map((x) => (
              <li key={x.slug}>
                <Link to={`/thuat-ngu/${x.slug}`}>{x.term}</Link>
                <span>{x.shortDef}</span>
              </li>
            ))}
          </ul>
        </section>
      )}

      <p
        style={{
          fontSize: ".85rem",
          color: "var(--chu-mo)",
          marginTop: "2rem",
        }}
      >
        Nội dung mang tính tham khảo, không phải tư vấn đầu tư hay tư vấn pháp
        lý.
      </p>
    </article>
  );
}
